import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';

type TradingOfferPartialityIconProps = {
  id?: string;
  isPartial: boolean;
};

const icons = {
  PARTIAL: 'shield-half',
  FULL: 'shield-fill',
};

const tooltips = {
  PARTIAL: 'TradingOfferPartialityTooltip',
  FULL: 'TradingOfferFullTooltip',
};

const TradingOfferPartialityIcon: FC<TradingOfferPartialityIconProps> = ({
  id,
  isPartial,
}) => {
  const { t } = useTranslate();

  const icon = isPartial ? icons.PARTIAL : icons.FULL;
  const tooltip = isPartial ? tooltips.PARTIAL : tooltips.FULL;

  return (
    <IconTooltip
      id={`partiality-icon-${id}`}
      icon={icon}
      tooltip={t(tooltip)}
      className="text-primary"
      wrapperClassName="d-inline"
    />
  );
};

export default TradingOfferPartialityIcon;
